import { render } from "./ReviewList.vue?vue&type=template&id=2248f70f"
import script from "./ReviewList.vue?vue&type=script&lang=ts"
export * from "./ReviewList.vue?vue&type=script&lang=ts"
script.render = render

export default script